/**
 * Промо/попап — по сути форма-объявление сбора внимания: оффер + CTA (+ опц. поле).
 * Шаблоны различаются формой показа (css), скелет общий.
 *  • modal  — затемнение + центр-карточка (OptinMonster).
 *  • banner — полоса во всю ширину (Hello Bar / Битрикс24).
 *  • corner — компактная карточка в углу (Sleeknote / Carrot quest).
 */
import type { MediaConfig, PromoContent, RuntimeWidgetConfig } from '@inbx/shared/schemas';

import { clear, el } from '../dom';

import type { BuildCtx, BuildInstance, WidgetTemplate } from './types';

function buildPromo(ctx: BuildCtx): BuildInstance {
  const c = (ctx.config.content ?? {}) as PromoContent;
  const m = (ctx.config.media ?? {}) as MediaConfig;
  clear(ctx.root);
  const root = el('div', 'w-promo');
  if (m.image_url) {
    const img = el('img', 'w-image');
    img.src = m.image_url;
    if (m.image_alt) img.alt = m.image_alt;
    root.appendChild(img);
  }
  const content = el('div', 'w-content');
  if (c.headline) content.appendChild(el('div', 'w-headline', c.headline));
  if (c.body_text) content.appendChild(el('p', 'w-body', c.body_text));
  if (c.cta_label) {
    const a = el('a', 'w-cta', c.cta_label);
    a.href = c.cta_url || '#';
    content.appendChild(a);
  }
  root.appendChild(content);
  ctx.root.appendChild(root);
  return {};
}

export const PROMO_TEMPLATES: WidgetTemplate[] = [
  { id: 'promo-modal', type: 'promo', build: buildPromo },
  { id: 'promo-banner', type: 'promo', build: buildPromo },
  { id: 'promo-corner', type: 'promo', build: buildPromo },
];
